<template>
  <bita-modal
    id="sale-agent-form"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoadingModal"
    @close="reset"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="title"
              label="عنوان"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.title"
            />

            <bita-texteditor
              name="content"
              ref="contentTextArea"
              label="محتوا"
              rules=""
              validation-container-class="col-lg-12"
              input-class="form-control"
              v-model="formData.content"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!formData.id"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="save"
      />
      <bita-bootbutton
        v-else
        title="بروزرسانی"
        type="primary"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="update"
      />
    </div>
  </bita-modal>
</template>
<script>
import { saleAgentApi } from "@/api/apiManagement.js";

export default {
  props: {
    title: String,
  },
  data() {
    return {
        isLoadingModal: false,
        formData: {},
        colWidth: 'col-6',
    };
  },
  methods: {
      setInitialData(_data) {
        this.formData = _data;  
        this.$refs.contentTextArea.setInitialValue(_data.content);
      },
      save() {
        this.$refs.form.validate()
          .then( (res) => {
            if ( res ) {
              this.isLoadingModal = true;
              saleAgentApi.create(this.formData)
                .then( (res) => {
                  this.$izitoast("success", "موفق!", res.data.message);
                  this.$emit("load-data");
                  this.$toggleModal("#sale-agent-form");
                })
                .finally( () => {
                  this.isLoadingModal = false;
                })
            }
          })
      },
      update() {
        this.$refs.form.validate()
          .then( (res) => {
            if ( res ) {
              this.isLoadingModal = true;
              let data = {
                title: this.formData.title,
                content: this.formData.content
              };
              saleAgentApi.update(this.formData.id, data)
                .then( (res) => {
                  this.$izitoast("success", "موفق!", res.data.message);
                  this.$emit("load-data");
                  this.$toggleModal("#sale-agent-form");
                })
                .finally( () => {
                  this.isLoadingModal = false;
                })
            }
          })
      },
      reset() {
        this.formData = {};
        this.$refs.form.reset();
        this.$refs.contentTextArea.reset();
      },
  }
};
</script>
